<template>
    <div class="w-full space-y-3">
        <Head title="Unit 4 Settings"/>
        <div class="flex justify-between">
            <h1 class="mt-2 text-2xl font-bold leading-7 text-gray-900 sm:text-3xl">Unit 4 Settings</h1>
        </div>
    </div>
    <div class="mt-5 bg-white py-6 px-4 sm:p-6 shadow mb-6">
        <div class="divide-y border-y divide-gray-200 overflow-hidden rounded-lg bg-gray-200 shadow sm:grid sm:grid-cols-2 sm:gap-px sm:divide-y-0">
            <div v-for="(unitFourArea, index) in unitFourAreas" :id="unitFourArea.id" :key="unitFourArea.title" :class="[index === 0 ? 'rounded-tl-lg rounded-tr-lg sm:rounded-tr-none' : '', index === 1 ? 'sm:rounded-tr-lg' : '', index === unitFourArea.length - 2 ? 'sm:rounded-bl-lg' : '', index === unitFourAreas.length - 1 ? 'rounded-bl-lg rounded-br-lg sm:rounded-bl-none' : '', 'relative group bg-white p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500']">
                <div>
                    <span :class="[unitFourArea.iconBackground, unitFourArea.iconForeground, 'rounded-lg inline-flex p-3 ring-4 ring-white']">
                        <component :is="unitFourArea.icon" class="h-6 w-6" aria-hidden="true" />
                    </span>
                </div>
                <div class="mt-8">
                    <h3 class="text-lg font-medium">
                        <a :href="unitFourArea.href" class="focus:outline-none">
                            <span class="absolute inset-0" aria-hidden="true" />
                            {{ unitFourArea.title }}
                        </a>
                    </h3>
                </div>
                <span class="pointer-events-none absolute top-6 right-6 text-gray-300 group-hover:text-gray-400" aria-hidden="true">
                    <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M20 4h1a1 1 0 00-1-1v1zm-1 12a1 1 0 102 0h-2zM8 3a1 1 0 000 2V3zM3.293 19.293a1 1 0 101.414 1.414l-1.414-1.414zM19 4v12h2V4h-2zm1-1H8v2h12V3zm-.707.293l-16 16 1.414 1.414 16-16-1.414-1.414z" />
                    </svg>
                </span>
            </div>
        </div>
    </div>
    <Unit4SyncStatus ref="syncStatusSlideout"/>
</template>

<script>
    import Authenticated from "@/Layouts/Authenticated";
    import {Link, Head, usePage, useForm} from "@inertiajs/vue3";
    import Unit4SyncStatus from "@/Components/SlideOuts/Unit4SyncStatus";
    import {StatusOnlineIcon, ClipboardListIcon, InformationCircleIcon} from '@heroicons/vue/outline'

    export default {
        layout: Authenticated,
        components: {
            Head,
            Link,
            Unit4SyncStatus
        },
        data() {
            return {
                unit_4_queue_open: usePage().props.unit_4_queue_open,
                unitFourAreas: [
                    {
                        title: 'Unit 4 Sync Status',
                        id: 'unit-4-sync-status',
                        icon: StatusOnlineIcon,
                        href: '#',
                        iconForeground: 'text-green-700',
                        iconBackground: 'bg-green-50',
                    },
                    {
                        title: 'Queued Invoices Report',
                        id: 'unit-4-open-invoice-queue',
                        icon: ClipboardListIcon,
                        href: '/unit-4-settings/queued-invoices-report',
                        iconForeground: 'text-sky-700',
                        iconBackground: 'bg-sky-50',
                    },
                    {
                        title: 'Queue History',
                        id: 'unit-4-queue-history',
                        href: '/unit-4-settings/queue-history',
                        icon: InformationCircleIcon,
                        iconForeground: 'text-amber-700',
                        iconBackground: 'bg-amber-50',
                    }
                ]
            }
        },
        methods: {
            openSyncStatusSlideout() {
                this.$refs.syncStatusSlideout.open();
            }
        },
        mounted() {
            const unitFourSyncStatus = document.getElementById('unit-4-sync-status');
            if (unitFourSyncStatus) {
                unitFourSyncStatus.onclick = this.openSyncStatusSlideout;
            }
        }
    }
</script>
